import { ArrowDownward, ArrowUpward, InfoOutlined, QrCode2 } from "@mui/icons-material";
import { Button, FormControl, IconButton, InputLabel, MenuItem, Select, TextField, Tooltip, Typography } from "@mui/material";
import { useAtom } from "jotai";
import { ChangeEvent, FC, Fragment, useEffect, useState } from "react";
import { modalDownloads, modalForms, modalInfoForm, modalQR, permissionsAtom } from "../../atoms/atom";
import AppBar from "../../components/app-bar/AppBar";
import { useAlert } from "../../components/contextProviders/AlertProvider";
import ModalDownloads from "../../components/form/downloads/ModalDownloads";
import ImportAnswersModal from "../../components/form/import-answers-modal/InfoFormModal";
import InfoFormModal from "../../components/form/info-form-modal/InfoFormModal";
import ModalForm from "../../components/form/modal-form/ModalForm";
import QrCodeModal from "../../components/qr-code-modal/QrCodeModal";
import { FormService } from "../../services/FormService";
import { FormDTO } from "../../types/FormDTO";
import { useUtils } from "../../utils/utilFunctions";
import { getLoading } from "../execution-events/ExecutionEvents";
import './Forms.scss';

const Forms: FC = () => {
	const [open, setOpen] = useAtom(modalForms);
	const [openInfo, setOpenInfo] = useAtom(modalInfoForm);
	const [, setOpenQR] = useAtom(modalQR);
	const [, setOpendowloads] = useAtom(modalDownloads);
	const [loading, setLoading] = useState(true);
	const [forms, setForms] = useState<FormDTO[]>([]);
	const [filteredForms, setFilteredForms] = useState<FormDTO[]>([]);
	const [editFormId, setEditFormId] = useState(0);
	const [editSecond, setEditSecond] = useState('');
	const [companyEdit, setCompanyEdit] = useState('');
	const [search, setSearch] = useState('');
	const [activeEdit, setActiveEdit] = useState(false);
	const [filter, setFilter] = useState('OPEN');
	const [fieldOrder, setFieldOrder] = useState<'CREATE' | 'CONCLUDE'>('CREATE');
	const [ordemAsc, setOrdemAsc] = useState(false);
	const [permissions] = useAtom(permissionsAtom);
	const { showError } = useAlert();
	const { verifyPermission, parseDate } = useUtils();
	const service = new FormService();

	const handleQr = (id: number) => {
		setEditFormId(id);
		setOpenQR(true);
	}

	const handleChangeSearch = (event: ChangeEvent<HTMLInputElement>) => {
		setSearch(event.target.value);
	}

	const handleInfo = (form: FormDTO) => {
		setEditFormId(form.id);
		setEditSecond(form.secondId);
		setCompanyEdit(form.companyName);
		setActiveEdit(form.active);
		setOpenInfo(true);
	}

	function mudaOrdem(field: 'CREATE' | 'CONCLUDE') {
		setFieldOrder(field);
		setOrdemAsc(!ordemAsc);
	}

	useEffect(() => {
		if (!!permissions.length) {
			verifyPermission(permissions, 'FORMS');
		}
	}, []);

	useEffect(() => {
		const load = async () => {
			try {
				const response = await service.listAll();
				if (response && response.data) {
					setForms(response.data);
					filterForms();
				}
			} catch (error) {
				showError();
			} finally {
				setLoading(false);
			}
		};
		if (!open && !openInfo) {
			load();
		}
	}, [open, openInfo]);

	useEffect(() => {
		filterForms();
	}, [filter, forms, search]);

	const filterForms = () => {
		setFilteredForms(filter === 'OPEN'
			? forms?.filter(item => item.active)
				.filter(item =>
				item.companyName.toUpperCase().includes(search.toUpperCase()) || item.cnpj.includes(search))
			: filter === 'CONCLUDE' 
				? forms?.filter(item => !item.active)
					.filter(item =>
				item.companyName.toUpperCase().includes(search.toUpperCase()) || item.cnpj.includes(search))
				: forms.filter(item =>
					item.companyName.toUpperCase().includes(search.toUpperCase()) || item.cnpj.includes(search))
		);
	}

	return (
		<Fragment>
			<AppBar
				modulo="Formulários"
			/>
			<div className="forms">
				<div className="top-forms">
					{permissions.includes('CREATE_FORMS') &&
						<Button
							id="add-form"
							variant="contained"
							color="success"
							onClick={() => setOpen(true)}
						>
							Novo formulário
						</Button>
					}
					<div className="form-filters">
						<Button
							id="add-form"
							variant="contained"
							color="info"
							onClick={() => setOpendowloads(true)}
						>
							Downloads
						</Button>
						<TextField
							sx={{width: { xs: '144px', md: '300px' }}}
							label="Buscar por nome ou CPF/CNPJ"
							id="form-search"
							size="small"
							value={search}
							onChange={handleChangeSearch}
						/>
						<FormControl
							size="small"
							sx={{width: { xs: '115px', md: '300px' }}}
						>
							<InputLabel>
								Filtrar formulários
							</InputLabel>
							<Select
							label='Filtrar formulários'
								id="select-form"
								value={filter}
								onChange={(e) => setFilter(e.target.value)}
							>
								<MenuItem
									key={'OPEN'}
									value={'OPEN'}
								>
									Abertos
								</MenuItem>
								<MenuItem
									key={'CONCLUDE'}
									value={'CONCLUDE'}
								>
									Concluídos
								</MenuItem>
								<MenuItem
									key={'ALL'}
									value={'ALL'}
								>
									Todos
								</MenuItem>
							</Select>
						</FormControl>
					</div>
				</div>
				{filteredForms && filteredForms.length
					? <div className="card-forms">
						<div className="header-forms">
							<p style={{display: "flex", justifyContent: "flex-start", width: "50vh"}}>Empresa</p>
							<p>CNPJ</p>
							<p className="pointer center" onClick={() => mudaOrdem('CREATE')}>
								Data de criação
								{obtemIconeOrdem('CREATE', fieldOrder, ordemAsc)}
							</p>
							<p className="pointer center" onClick={() => mudaOrdem('CONCLUDE')}>
								Data de conclusão
								{obtemIconeOrdem('CONCLUDE', fieldOrder, ordemAsc)}
							</p>
							<p>Respostas concluídas</p>
							<p>Status</p>
							<p style={{width: "13vh"}}>Ações</p>
						</div>
						<div className="body-forms">
							{filteredForms.sort((a, b) => {
								let valueA;
								let valueB;
								switch (fieldOrder) {
									case 'CREATE':
										valueA = parseDate(a.createdAt).getTime();
										valueB = parseDate(b.createdAt).getTime();
										break;
									default:
										valueA = parseDate(a.finishedAt).getTime();
										valueB = parseDate(b.finishedAt).getTime();
										break;
								}
								return ordemAsc
									? (valueA) - (valueB)
									: (valueB) - (valueA);
							}).map((form) => (
								<div className="linha-form">
									<p id="company-name-form">{form.companyName}</p>
									<p>{form.cnpj}</p>
									<p>{form.createdAt}</p>
									<p className="flex-none">{form.finishedAt ? form.finishedAt : '--'}</p>
									<p>{form.count}</p>
									<Typography color={form.active ? '#3c6fd5ff' : 'springgreen'}>
										{form.active ? "Aberto" : "Concluído"}
									</Typography>
									<p style={{display: "flex", justifyContent: "space-between", width: "13vh"}}>
										<Tooltip
											title="Ver QR code"
											placement="top"
										>
											<IconButton
												color="warning"
												onClick={() => handleQr(form.id)}
												disabled={!form.active}
											>
												<QrCode2 />
											</IconButton>
										</Tooltip>
										<Tooltip
											title="Ver detalhes"
											placement="top"
										>
											<IconButton
												color="info"
												onClick={() => handleInfo(form)}
											>
												<InfoOutlined />
											</IconButton>
										</Tooltip>
									</p>
								</div>
							))}
						</div>
					</div>
					: loading
						? getLoading()
						: <div className="empty-forms">
							<h3>Nenhum formulário encontrado para os filtros aplicados</h3>
						</div>
				}
			</div>
			<ModalForm/>
			<ModalDownloads/>
			<QrCodeModal
				module="a pesquisa"
				link={`https://copsoq2.inovação.seg.br/${editFormId}/login`}
			/>
			<InfoFormModal
				id={editFormId}
				secondId={editSecond}
				companyName={companyEdit}
				active={activeEdit}
			/>
			<ImportAnswersModal
				id={editFormId}
			/>
		</Fragment>
	);

	function obtemIconeOrdem(field: string, fieldOrder: string, ordemAsc: boolean) {
		return field === fieldOrder
			? ordemAsc
				? <ArrowUpward sx={{marginLeft: "10px"}}/>
				: <ArrowDownward sx={{marginLeft: "10px"}}/>
			: <ArrowDownward sx={{marginLeft: "10px"}}/>;
	}
}

export default Forms;